<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"   @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
    // 日期格式化小工具 (產出 yyyy-MM-dd HH:mm:ss)
    const formatDateTime = (date) => {
      const pad = (n) => (n < 10 ? '0' + n : n);
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    };
    // 1. 取得當前時間，並將時分秒設定為今天的 23:59:59
    const endDate = new Date();
    endDate.setHours(23, 59, 59, 999);
    const defaultEndTime = formatDateTime(endDate);
    // 2. 取得七天前的時間，並將時分秒設定為 00:00:00
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 6); 
    startDate.setHours(0, 0, 0, 0);
    const defaultStartTime = formatDateTime(startDate);
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import Qs from 'qs'
    //接口地址url的统一管理
    import URL from '@/views/analyse/util/url'
    import download from "@/utils/download";
    import DateUtil from '@/utils/IM/tradeDataUtil'
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
        },
      mounted() {
        console.log()
      },
      methods: {
        dataChange(url, option, suc, fail) {
          this.$axios.post(url, Qs.stringify(option || {})).then(res => {
            if (suc && (typeof suc == 'function')) suc(res)
          }).catch(res => {
            if (fail && (typeof fail == 'function')) fail(res)
          })
        },
        /*表格按钮点击事件*/
        bthClick(clickName, row) {
          console.info(clickName)
          if (clickName == 'synData') {
            this.dataChange(URL.deviceVn.syndata + '/' + row.id, { businessType: row.businessType }, res => {
              if (res.code == 0) {
                this.$message.success('suc')
              } else {
                this.$message.error(res.message)
              }
            })
          }
        },
        formclick(clickName, data){
            if("查询" == clickName || window.$t('analyse.bt.search') == clickName){
                this.$nextTick(() => {
                  if (this.$refs.childTable) {
                      this.$refs.childTable.defaultQueryData(data);
                  }
              });
            }
          if(window.$t('analyse.bt.down') == clickName){
            const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:true});
            download.exportExcel(URL.deviceVn.export,param,window.$t('analyse.device.exportFile'));
          }
        },
      },
      data () {
          return {
              /*from查询表单*/
              formData:{
                hasLable: true,
                cols:[
                      { title:$t('analyse.device.account'), field: 'accountNo'},
                      { title: window.$t("analyse.device.startTime"), field: 'recordTime',type:5,format:"yyyy-MM-dd HH:mm:ss", data: defaultStartTime},
                      { title: window.$t("analyse.device.endTime"), field: 'recordTimeEnd',type:5,format:"yyyy-MM-dd HH:mm:ss", data: defaultEndTime},
                      { title: window.$t('analyse.device.recordType'), field: 'recordType'},
                      { title: window.$t('analyse.device.channel'), field: 'channel'},
                      { title: window.$t('analyse.device.medium'), field: 'medium'},
                      { title: window.$t('analyse.device.series'), field: 'series'},
                      { title: window.$t('analyse.device.packageName'), field: 'packageName'},
                      { title:"businessType", field: 'businessType',data:DateUtil.getParamKey(this.$route.params), hidden:true},
                      {click:window.$t('analyse.bt.search')},
                      {click:window.$t('analyse.bt.down')}
                  ]
              },
              /*table生成*/
              pageData: {
                  isShow: false,
                  queryUrl: URL.deviceVn.detail, //请求路径和参数
                  selection: true,
                  sequence: true,
                  height: 'calc(100vh - 250px)',
                  cols: [
                      { title: window.$t('analyse.device.account'), field: 'accountNo'},
                      { title: window.$t('analyse.device.faidStr'), field: 'faidStr'},
                      { title: window.$t('analyse.device.androidId'), field: 'androidId'},
                      { title: window.$t('analyse.device.recordType'), field: 'recordType'},
                      { title: window.$t('analyse.device.operates'), field: 'operates'},
                      { title: window.$t('analyse.device.platform'), field: 'platform'},
                      { title: window.$t('analyse.device.osVersion'), field: 'osVersion'},
                      { title: window.$t('analyse.device.vendor'), field: 'manufacturer'},
                      { title: window.$t('analyse.device.networkType'), field: 'networkType'},
                      { title: 'ip', field: 'ipAddress'},
                      { title: window.$t('analyse.device.ipAdd'), field: 'ipAdd'},
                      { title: window.$t('analyse.device.series'), field: 'series'},
                      { title: window.$t('analyse.device.packageName'), field: 'packageName'},
                      { title: window.$t('analyse.device.appVerCode'), field: 'appVerCode'},
                      { title: window.$t('analyse.device.channel'), field: 'channel'},
                      { title: window.$t('analyse.device.source'), field: 'source'},
                      { title: window.$t('analyse.device.medium'), field: 'medium'},
                      { title: window.$t('analyse.device.businessType'), field: 'businessType'},
                      { title: window.$t('analyse.device.valueOne'), field: 'valueOne'},
                      { title: window.$t('common.status'), field: 'status',render: (data, full) => {
                          return parseInt(data.toString())===1?"已處理":"未處理";
                        }},
                      { title: window.$t('analyse.device.recordTime'), field: 'recordTime',width:200},
                    {
                      title: '操作', btnClick: [
                        { name: '同步', click: 'synData', type: 'primary', icon: 'el-icon-edit', auth: 'analyse:chshinDeposit:sel' }
                      ]
                    }
                  ]
              }
          }
      }
    }
</script>
